import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * + * {
    margin-top: var(--space-400);
  }
`

export const Image = styled.img`
  display: inline-block;
  max-width: 360px;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 480px;

  & > * + * {
    margin-top: var(--space-400);
  }

  ${mediaQueries.laptopS} {
    display: grid;
    max-width: 480px;
    grid-template-columns: 1.2fr 1fr;

    & > * + * {
      border-top: 0;
      margin-top: 0;
      border-left: 1px solid var(--bg-transparent-strongest);
    }
  }
`

export const Description = styled.p`
  font-size: var(--font-size-300);
  color: var(--text-secondary);
  line-height: var(--font-line-height-300);
  padding: 0 var(--space-400);
  display: grid;
  grid-template-columns: 16px auto;
  gap: var(--space-400);
  align-items: center;
  text-align: left;
`
